module.exports = __webpack_public_path__ + "img/shio.632f30b1.jpg";